function CircleLoader() {
  return (
    <div className="relative h-12 w-12">
      {/* <div className="absolute inset-2 animate-spin rounded-full border-[3px] border-transparent border-t-white border-r-white"></div> */}

      <div className="absolute inset-0 animate-spin rounded-full border-[3px] border-gray border-l-gray_clr-300 [animation-direction:reverse] [animation-duration:1.2s]"></div>
    </div>
  );
}
export default function OverlayLoader() {
  return (
    // <div className="fixed inset-0 z-50 place-items-center bg-black/50 p-4">
    <div className="fixed top-0 left-0 right-0 bottom-0 h-screen z-50 place-items-center bg-Black/50 p-4 flex items-center justify-center">
      <div className="w-full p-4 flex items-center justify-center">
        <CircleLoader />
      </div>
    </div>
  );
}
